export interface IPrescription {
    id: number;
    prescriptionDate: Date;
    doctorId: number;
    patientId: number;
    opdNumber: string;
    opdId: number;
    ipdId?: number;
    ipdNumber?: string;
    patientDailyReportId?: number;
    prescriptionType?: PrescriptionType;
    diagnosis: string;
    treatmentAdviceOPD?: string;
    followUpDate?: Date | string | null;
    followUpTime?: string | null;
    prescriptionItems: IPrescriptionItem[];
}

export enum PrescriptionType {
    OPD = 1,
    IPD = 2,
    DailyReport = 3
}

export interface IPrescriptionItem {
    drugId: number;
    drugName: string;
    dosePattern: string;
    duration: string;
    route?: string;
    indication?: string;
    mealRelation?: number;
    instruction?: string;
}
export interface IPrescriptionTemplate {
    id: number;
    name: string;
    description?: string;
    doctorId: number;
    prescriptionTemplateDetails: IPrescriptionItem[];
}
